import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject, Subscriber } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { InstallationService } from '../../services/installation.service';

import { HeatingCircuitIgnoredModalComponent } from './heating-circuit-ignored-modal.component';

@Injectable({
  providedIn: 'root',
})
export class HeatingCircuitIgnoredModalService {
  heatingCircuitIgnoredDialogRef: MatDialogRef<HeatingCircuitIgnoredModalComponent>;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private dialog: MatDialog, private installationService: InstallationService) {}

  openHeatingCircuitIgnoredDialog(doNotAskAgainModal?: boolean): Observable<any> {
    this.heatingCircuitIgnoredDialogRef = this.dialog.open(HeatingCircuitIgnoredModalComponent, {
      width: '535px',
      panelClass: 'heating-circuit-ignored-dialog',
      disableClose: true,
      data: {
        doNotAskAgain: doNotAskAgainModal,
      },
    });

    return this.heatingCircuitIgnoredDialogRef.afterClosed();
  }

  showModalWhenSrcIsActive(doNotAskAgainModal?: boolean): Observable<boolean> {
    const informHeatingCircuitIsIgnored = !doNotAskAgainModal;
    const informOperatingModeIsIgnored =
      localStorage.getItem('doNotAskAgainModalIsIgnored') !== 'false' && doNotAskAgainModal;
    const isSrcActive = this.installationService.isSrcActive$.getValue();

    return new Observable<boolean>((o: Subscriber<boolean>): void => {
      if (isSrcActive && (informOperatingModeIsIgnored || informHeatingCircuitIsIgnored)) {
        this.openHeatingCircuitIgnoredDialog(doNotAskAgainModal)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((status) => {
            if (status) {
              this.onDestroy();
              o.next(status.action === 'close');
              o.complete();
            }
          });
      } else {
        o.next(!isSrcActive);
        o.complete();
      }
    });
  }

  onDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
